import { render, staticRenderFns } from "./StructuredData.vue?vue&type=template&id=3e765b54&scoped=true&"
import script from "./StructuredData.vue?vue&type=script&lang=js&"
export * from "./StructuredData.vue?vue&type=script&lang=js&"
import style0 from "./StructuredData.vue?vue&type=style&index=0&id=3e765b54&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e765b54",
  null
  
)

component.options.__file = "StructuredData.vue"
export default component.exports